<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang='less' scoped>
#app {
  font-family: Helvetica, Arial, sans-serif;
  min-width: 1024px;
}
/deep/ body .el-table--scrollable-y {

  .el-table__body-wrapper::-webkit-scrollbar {
    width: 9px;
    height: 9px;
  }
  .gutter {
    width: 10px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue